import { getSnowplowEventPayload, logAnalyticsEvent } from '../analytics';
import { ANALYTICS_CATEGORIES, SNOWPLOW_EVENTS } from '../analytics.const';

const {
	MARKETPLACE: { VEHICLE_LIST },
} = ANALYTICS_CATEGORIES;

export const triggerBackToTopClickedEvent = (): void => {
	const eventPayload = getSnowplowEventPayload({
		category: VEHICLE_LIST,
		name: 'dlr_mrktplace_vehicle_list_back_to_top_clicked',
		schemaName: SNOWPLOW_EVENTS.CLICK.SCHEMA,
		version: SNOWPLOW_EVENTS.CLICK.VERSION,
	});

	logAnalyticsEvent({ eventPayload });
};

export const triggerVehicleGradeHoverEvent = (): void => {
	const eventPayload = getSnowplowEventPayload({
		category: VEHICLE_LIST,
		name: 'dlr_mrktplace_vehicle_list_vehicle_grade_hovered',
		schemaName: SNOWPLOW_EVENTS.HOVER.SCHEMA,
		version: SNOWPLOW_EVENTS.HOVER.VERSION,
	});

	logAnalyticsEvent({ eventPayload });
};

export const triggerVehicleCardClickEvent = (enquiryId: number): void => {
	const eventPayload = getSnowplowEventPayload({
		category: VEHICLE_LIST,
		customData: { label: `${enquiryId}` },
		name: 'vehicle_card_click',
		schemaName: SNOWPLOW_EVENTS.CLICK.SCHEMA,
		version: SNOWPLOW_EVENTS.CLICK.VERSION,
	});

	logAnalyticsEvent({ eventPayload });
};

export const triggerVehicleRowViewedEvent = ({
	columnCount,
	dwellTimeMs,
	totalCars,
	vehicleCards,
}: {
	columnCount: number;
	dwellTimeMs: number;
	totalCars: number;
	vehicleCards: { enquiryId: number; position: number }[];
}): void => {
	const eventPayload = getSnowplowEventPayload({
		category: VEHICLE_LIST,
		customData: {
			label: JSON.stringify({
				column_count: columnCount,
				dwell_time: dwellTimeMs,
				total_cars: totalCars,
				vehicle_cards: vehicleCards.map(({ enquiryId, position }) => ({ enquiry_id: enquiryId, position })),
			}),
		},
		name: 'vehicle_row_viewed',
		schemaName: SNOWPLOW_EVENTS.LOAD.SCHEMA,
		version: SNOWPLOW_EVENTS.LOAD.VERSION,
	});

	logAnalyticsEvent({ eventPayload });
};

export const triggerVehicleListFetchedEvent = (paginatedListOfIds: string): void => {
	const eventPayload = getSnowplowEventPayload({
		category: VEHICLE_LIST,
		customData: { label: paginatedListOfIds },
		name: 'vehicles_loaded',
		schemaName: SNOWPLOW_EVENTS.LOAD.SCHEMA,
		version: SNOWPLOW_EVENTS.LOAD.VERSION,
	});

	logAnalyticsEvent({ eventPayload });
};

export const triggerVehicleCardPrevImageClickedEvent = ({
	enquiryId,
	fromImage,
	toImage,
	ttlImages,
}: {
	enquiryId: number;
	fromImage: string;
	toImage: string;
	ttlImages: number;
}): void => {
	const eventPayload = getSnowplowEventPayload({
		category: VEHICLE_LIST,
		customData: {
			label: JSON.stringify({ enquiry_id: enquiryId, from_image: fromImage, to_image: toImage, ttl_images: ttlImages }),
		},
		name: 'dlr_vehicle_card_prev_image_clicked',
		schemaName: SNOWPLOW_EVENTS.CLICK.SCHEMA,
		version: SNOWPLOW_EVENTS.CLICK.VERSION,
	});

	logAnalyticsEvent({ eventPayload });
};

export const triggerVehicleCardNextImageClickedEvent = ({
	enquiryId,
	fromImage,
	toImage,
	ttlImages,
}: {
	enquiryId: number;
	fromImage: string;
	toImage: string;
	ttlImages: number;
}): void => {
	const eventPayload = getSnowplowEventPayload({
		category: VEHICLE_LIST,
		customData: {
			label: JSON.stringify({ enquiry_id: enquiryId, from_image: fromImage, to_image: toImage, ttl_images: ttlImages }),
		},
		name: 'dlr_vehicle_card_next_image_clicked',
		schemaName: SNOWPLOW_EVENTS.CLICK.SCHEMA,
		version: SNOWPLOW_EVENTS.CLICK.VERSION,
	});

	logAnalyticsEvent({ eventPayload });
};

export const triggerVehicleCardImageLoadedEvent = ({
	enquiryId,
	fromImage,
	toImage,
	ttlImages,
}: {
	enquiryId: number;
	fromImage: string;
	toImage: string;
	ttlImages: number;
}): void => {
	const eventPayload = getSnowplowEventPayload({
		category: VEHICLE_LIST,
		customData: {
			label: JSON.stringify({ enquiry_id: enquiryId, from_image: fromImage, to_image: toImage, ttl_images: ttlImages }),
		},
		name: 'dlr_vehicle_card_image_loaded',
		schemaName: SNOWPLOW_EVENTS.LOAD.SCHEMA,
		version: SNOWPLOW_EVENTS.LOAD.VERSION,
	});

	logAnalyticsEvent({ eventPayload });
};

export const triggerMobilizeRowToggleEvent = (expanded: boolean): void => {
	const eventPayload = getSnowplowEventPayload({
		category: VEHICLE_LIST,
		name: `dlr_mobilize_row_${expanded ? 'expanded' : 'collapsed'}`,
		schemaName: SNOWPLOW_EVENTS.CLICK.SCHEMA,
		version: SNOWPLOW_EVENTS.CLICK.VERSION,
	});

	logAnalyticsEvent({ eventPayload });
};

export const triggerMobilizeRowShowMoreClickedEvent = (): void => {
	const eventPayload = getSnowplowEventPayload({
		category: VEHICLE_LIST,
		name: 'dlr_mobilize_row_show_more_clicked',
		schemaName: SNOWPLOW_EVENTS.CLICK.SCHEMA,
		version: SNOWPLOW_EVENTS.CLICK.VERSION,
	});

	logAnalyticsEvent({ eventPayload });
};

export const triggerMobilizeRowVehicleCardClickedEvent = (enquiryId: number): void => {
	const eventPayload = getSnowplowEventPayload({
		category: VEHICLE_LIST,
		customData: { label: `${enquiryId}` },
		name: 'dlr_mobilize_row_vehicle_card_clicked',
		schemaName: SNOWPLOW_EVENTS.CLICK.SCHEMA,
		version: SNOWPLOW_EVENTS.CLICK.VERSION,
	});

	logAnalyticsEvent({ eventPayload });
};
